import { createEmitter } from 'ts_utils';

export class RAButton {
	private _ui:HTMLDivElement;
	private _enabled:boolean = false;
	
	private _clickEmitter = createEmitter<MouseEvent>();
	public get click() { return this._clickEmitter.event; }
	
	constructor(ui:HTMLDivElement){
		this._ui = ui;
		this._init();
	}
	
	private _init():void {
		this._ui.addEventListener("click", (e) => {
			if (this._enabled){
				this._clickEmitter.emit(e);
			}
		});
	}
	
	public addCssClass(className:string):void {
		if (!this._ui.classList.contains(className)){
			this._ui.classList.add(className);
		}
	}
	
	public removeCssClass(className:string):void {
		this._ui.classList.remove(className);
	}
	
	public get enabled() { return this._enabled; }
	public set enabled(value:boolean){ 
		this._enabled = value;
		if (this._enabled){
			this._ui.classList.remove('disabled');
		}
		else if (!this._ui.classList.contains('disabled')){
			this._ui.classList.add('disabled');
		}
	}
}